import {IComponentOptions} from "angular";

export const InlineCheckboxComponent: IComponentOptions = {
    bindings: {
        label: "@",
        helpText: "@?",
        classes: "@",
        labelDescription: "@",
        name: "@",
        displayErrorState: "<",
        requiredFlag: "=",
        disabledFlag: "=",
        readonlyFlag: "=",
        valueModel: "="
    },
    template: require("./inline-checkbox.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/widget/inline-checkbox/inline-checkbox.component.ts